import { Pipe, PipeTransform } from '@angular/core'
import { isNumber } from '../utils/type-checks'

@Pipe({
    name: 'percentage',
})
export class PercentagePipe implements PipeTransform {
    // assumes input 0..1
    transform(value: unknown): string {
        if (!isNumber(value)) return ''

        return `${(value * 100).toFixed(2)} %`
    }
}
